$(".slick").slick({
  /*infinite: true,
  arrows: false,
  dots: true,
  autoplay: true,
  speed: 800,
  slidesToShow: 1,
  slidesToScroll: 1,*/
  adaptiveHeight: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.slider-nav',
});

 $('.slider-nav').slick({
   slidesToShow: 3,
   slidesToScroll: 1,
   asNavFor: '.slick',
   dots: true,
   focusOnSelect: true
 });


$('a[data-slide]').click(function(e) {
   e.preventDefault();
   var slideno = $(this).data('slide');
   $('.slider-nav').slick('slickGoTo', slideno - 1);
   $('.slider-action a').removeClass('active');
   $(this).addClass('active');
 }); 


$(".slick-default").slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  adaptiveHeight: false,
  autoplay: false,
  autoplaySpeed: 2000,
  fade: true,
  cssEase: 'linear',
  prevArrow:"<button type='button' class='slick-prev pull-left btn'><i class='icon-bx_bx-left-arrow-circle' aria-hidden='true'></i></button>",
  nextArrow:"<button type='button' class='slick-next pull-right btn'><i class='icon-bx_bx-right-arrow-circle' aria-hidden='true'></i></button>",
});


$(".slick-default-three").slick({
  dots: true,
  infinite: false,
  arrows: false,
  speed: 300,
  slidesToShow: 3,
  adaptiveHeight: false,
  autoplay: false,
  autoplaySpeed: 2000,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 481,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});



$('.slider-vert-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.slider-vert-nav',
  adaptiveHeight: true,
  infinite: false,
  dots: false
});

$('.slider-vert-nav').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  asNavFor: '.slider-vert-for',
  dots: false,
  centerMode: false,
  focusOnSelect: true,
  vertical: true,
  infinite: false,
  arrows: false
});